import type React from "react";

const BASE_STATUS_POPOVER_ITEMS = [
  { label: "Новая", value: "Новая" },
  { label: "Рассмотрена и принята", value: "Рассмотрена и принята" },
  { label: "Рассмотрена и отказано", value: "Рассмотрена и отказано" },
  { label: "Архивная", value: "Архивная" },
] as const;

const BASE_AUDIT_STATUS_POPOVER_ITEMS = [
  { label: "Пройден", value: "пройден" },
  { label: "Не пройден", value: "не пройден" },
] as const;

export type StatusPopoverItem = { label: string; value: string };

export const getStatusButtonClassName = (
  status: string,
  styles: {
    btnNew: string;
    btnNewBlue: string;
    btnNewPurple: string;
  },
) => {
  if (status === "Рассмотрена (граница охранной зоны)") {
    return styles.btnNewBlue;
  }
  if (status === "Рассмотрена (сокращенная заявка)") {
    return styles.btnNewPurple;
  }
  return styles.btnNew;
};

export const getStatusButtonStyle = (status: string): React.CSSProperties => {
  if (status === "Рассмотрена (граница охранной зоны)") {
    return { backgroundColor: "#2196F3", color: "#fff" };
  }
  if (status === "Рассмотрена (сокращенная заявка)") {
    return { backgroundColor: "#9C27B0", color: "#fff" };
  }
  return { backgroundColor: "#495A64", color: "#fff" };
};

export const getStatusPopoverItems = (): StatusPopoverItem[] => [
  ...BASE_STATUS_POPOVER_ITEMS,
];

export const getAuditStatusPopoverItems = (): StatusPopoverItem[] => [
  ...BASE_AUDIT_STATUS_POPOVER_ITEMS,
];
